import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {Icon, Menu, MenuItem} from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";

// Hooks
import {useAuth} from "../auth/auth";

// Actions
import {downloadExcel, downloadJson, downloadPdf} from "../content/content-actions";

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        downloadPdf: (pdfId, pdfType, clientId) => dispatch(downloadPdf(pdfId, pdfType, clientId)),
        downloadExcel: (excelId, excelType, clientId) => dispatch(downloadExcel(excelId, excelType, clientId)),
        downloadJson: (jsonId, jsonType, clientId) => dispatch(downloadJson(jsonId, jsonType, clientId)),
    }
};

const DownloadStocksPopover = (props) => {
    const {data, children} = props;

    const [downloadIsOpen, setDownloadIsOpen] = useState(false);

    const {selectedClient} = useAuth();

    const {downloadPdf, downloadExcel, downloadJson} = useReduxDispatch();

    const {t} = useTranslation("stocks");

    const fileName = data.file_name;

    return (
        <Popover2
            isOpen={downloadIsOpen}
            onClose={() => setDownloadIsOpen(false)}
            content={
                <Menu style={{ minWidth: "auto", maxWidth: "none" }}>
                    <MenuItem text={t("download.pdf")} onClick={() => {
                        downloadPdf(fileName, "stock", selectedClient);
                        setDownloadIsOpen(false);
                    }} />
                    <MenuItem text={t("download.xls")} onClick={() => {
                        downloadExcel(fileName, "stock", selectedClient);
                        setDownloadIsOpen(false);
                    }} />
                    <MenuItem text={t("download.json")} onClick={() => {
                        downloadJson(fileName, "stock", selectedClient);
                        setDownloadIsOpen(false);
                    }} />
                </Menu>
            }
            placement={!!children ? "bottom" : "left"}
        >
            <div onClick={() => setDownloadIsOpen(!downloadIsOpen)}>
                {children || (
                    <Icon 
                        icon="download" 
                        iconSize={20} 
                        style={{cursor: "pointer"}}
                    />
                )}
            </div>
        </Popover2>
    )
}

export default DownloadStocksPopover;
